// src/stores/authStore.ts

import { create } from 'zustand';
import { persist, type PersistOptions } from 'zustand/middleware';
import type { Developer } from '@/types/developer';

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  currentDeveloper: Developer | null;
  
  login: (token: string, developer: Developer) => void;
  logout: () => void;
  setCurrentDeveloper: (developer: Developer) => void;
}

const persistOptions: PersistOptions<AuthState, Pick<AuthState, 'token' | 'isAuthenticated' | 'currentDeveloper'>> = {
  name: 'auth-storage',
  partialize: (state) => ({
    token: state.token,
    isAuthenticated: state.isAuthenticated,
    currentDeveloper: state.currentDeveloper,
  }),
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      isAuthenticated: false,
      currentDeveloper: null,
      
      login: (token: string, developer: Developer) => {
        set({ 
          token, 
          isAuthenticated: true, 
          currentDeveloper: developer 
        });
        localStorage.setItem('developer_token', token);
      },
      
      logout: () => {
        set({ 
          token: null, 
          isAuthenticated: false, 
          currentDeveloper: null 
        });
        localStorage.removeItem('developer_token');
      },
      
      setCurrentDeveloper: (developer: Developer) => {
        set({ currentDeveloper: developer });
      },
    }),
    persistOptions
  )
);

// ✅ 添加获取当前开发者 ID 的工具函数
export const getCurrentDeveloperId = (): string | null => {
  const { currentDeveloper } = useAuthStore.getState();
  return currentDeveloper?.id || null;
};